import { combineReducers } from 'redux'
import thunk from 'redux-thunk'
import system from './system.reducer'
import ciclo_entrega from './ciclo-entrega.reducer'
import picking from './picking.reducer'
import deliveryTransfer from './delivery-transfer.reducer'
import retorno_veiculo from './retorno-veiculo.reducer'
import ordem_coleta from './ordem-coleta.reducer'
import entrega_por_empresa from './entrega-por-empresa.reducer'
import dashboard from './dashboard.reducer'
import notification from './notification.reducer'

export default combineReducers(
  {
    system,
    ciclo_entrega,
    picking,
    deliveryTransfer,
    retorno_veiculo,
    ordem_coleta,
    entrega_por_empresa,
    dashboard,
    notification,
  },
  { thunk },
)
